/*let templateSchemaFormPicklist = `
    <div class="form-group" ng-class="{'has-error': hasError(), 'has-success': hasSuccess(), 'has-feedback': form.feedback !== false }" >
        <label class="control-label" ng-show="showTitle()">{{form.title}}</label>

        <p class="input-group">
          <input type="text" class="form-control" uib-datepicker-popup="{{form.format}}" ng-model="$$value$$" is-open="opened" datepicker-options="form.dateOptions" ng-required="true" close-text="Close" alt-input-formats="form.altInputFormats" />
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="opened = true"><i class="glyphicon glyphicon-calendar"></i></button>
          </span>
        </p>

        <p uib-timepicker ng-model="mytime" hour-step="form.hstep" minute-step="form.mstep" show-meridian="form.ismeridian"></p>

    </div>
`;*/

let templateSchemaFormPercent = `
    <div class="form-group" ng-class="{'has-error': hasError(), 'has-success': hasSuccess(), 'has-feedback': form.feedback !== false }" >
        <label class="control-label" ng-show="showTitle()">{{form.title}}</label>
        <span style="float: right">{{$$value$$ | number:'0'}}%</span>
        <input type="range" min="0" max="100" ng-model="$$value$$" form="form" />
    </div>
`;

angular.module("schemaForm").run(["$templateCache", function($templateCache) {
  $templateCache.put("directives/decorators/bootstrap/range/percent.html",templateSchemaFormPercent);
}]);

angular.module('schemaForm-percent', ['schemaForm']).config(
  ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider,  schemaFormDecoratorsProvider, sfPathProvider) {

      var percent = function(name, schema, options) {

        console.log(name);
        console.log(schema);
        console.log(options);

        if (schema.type == 'number' && schema.format == 'percent') {
          var f = schemaFormProvider.stdFormObj(name, schema, options);
          f.key  = options.path;
          f.type = 'percent';
          options.lookup[sfPathProvider.stringify(options.path)] = f;
          return f;
        }
      };

      schemaFormProvider.defaults.number.unshift(percent);

      //Add to the bootstrap directive
      schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'percent',
        'directives/decorators/bootstrap/range/percent.html');
      schemaFormDecoratorsProvider.createDirective('percent',
        'directives/decorators/bootstrap/range/percent.html');
    }]);



// WEBPACK FOOTER //
// ./client/app/schema-form.percent.js